import { render, staticRenderFns } from "./CreditNoteViewer.vue?vue&type=template&id=3abd6b52&"
import script from "./CreditNoteViewer.vue?vue&type=script&lang=js&"
export * from "./CreditNoteViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports